export default "__VITE_ASSET__Vc2tO0k2__"